import * as React from "react";
import { userInfoStore } from "Stores/UserInfoStore";
import { Loader } from "Components/General/Loader";
import { useParams } from "react-router-dom";

// Future: This is only a Temporary Redirect to the old backend Functionality.
export const TaskDetail = () => {
  const params = useParams();
  React.useEffect(() => {
    const { csrf } = userInfoStore;
    const { id } = params;
    const cmd: string = "directtasks";

    const href =
      document.location.origin + "/" + window.GLOBAL.API_BASE + `MainServlet?cmd=${cmd}&id=${id}&csrf=${csrf}`;
    window.location.assign(href);
  }, []);

  return <Loader />;
};
